import { AdminTopbar } from "@/components/admin/AdminLayout";
import { DemandesVerificationPanel, MessagesContactPanel } from "@/components/admin/InboxPanels";

function Messages() {
  return (
    <>
      <AdminTopbar title="Messages" subtitle="Prises de contact et demandes de vérification reçues depuis le site public" />
      <div className="flex-1 overflow-y-auto p-6 space-y-4">
        <DemandesVerificationPanel />
        <MessagesContactPanel />
      </div>
    </>
  );
}

export default Messages;
